import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";

export interface RecaptchaState {
  isRecaptchaValidated: boolean;
  recaptchaToken: string;
}

const initialState: RecaptchaState = {
  isRecaptchaValidated: false,
  recaptchaToken: ""
};

export const recaptchaSlice = createSlice({
  name: "recaptcha",
  initialState,
  reducers: {
    setClientRecaptchaValidation: (state, action) => {
      state.isRecaptchaValidated = !!action.payload;
      state.recaptchaToken = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(hydrate, (state, action: PayloadAction<string>) => {
      return {
        ...state,
        ...action.payload[recaptchaSlice.name]
      };
    });
  }
});

export const { setClientRecaptchaValidation } = recaptchaSlice.actions;
